import { matchPath } from 'react-router';

export const routes = {
  COMPANY_ROOT: '/company',
  COMPANY: '/company/:id',
  LOGIN: '/login/',
  PASSWORD_RESET: '/password-reset/',
  PASSWORD_RESET_CONFIRM: '/password-reset/:token/',
  PASSWORD_RESET_LINK_EXPIRED: '/password-reset/reject/',
  FUND_ROOT: '/fund',
  FUND: '/fund/:id',
  FUND_SCENARIOS: '/fund/:fundId/scenarios/',
  KPI: '/kpis',
  INVESTMENT_ROOT: '/investment',
  INVESTMENT: '/investment/:id',
};


// Routes that do not need authentication. These will not be redirected to login.
export const NON_AUTHENTICATED_ROUTES = [
  routes.LOGIN,
  routes.PASSWORD_RESET,
  routes.PASSWORD_RESET_LINK_EXPIRED,
  routes.PASSWORD_RESET_CONFIRM
]


// Checks if current path is auth or non-auth. Includes string matching.
export const isNonAuthRoute = () => {

  const matches = NON_AUTHENTICATED_ROUTES.map(r => !!matchPath(
    window.location.pathname,
    {
      path: r,
      exact: true,
    }
  ))

  return matches.includes(true)
}